<template>
  <div id="wrapper">
    <div id="main" class="clearfix">
      <Header />
      <div id="content">
        <router-view></router-view>
      </div>
      <Footer />
    </div>
  </div>
</template>
<script setup>
import Header from "./components/header.vue";
import Footer from "./components/footer.vue";
</script>
<style>
:root {
  --font-size-small: 12px;
  --font-size-medium: 16px;
  --font-size-large: 20px;
  --current-font-size: var(--font-size-medium); /* 默认字号 */
}
</style>
